import { useState } from "react";
import { useLicenseDetails } from "../../contexts/licenseDetails";
import LicenseService from "../../services/LicensesService";
import Button from "../Button/Button";
import Input from "../Input/Input";
import {
   getZodFieldErrors,
   licenseSerialNumberSchema,
} from "../../validations/license-subpages.schema";

export function LicenseUpdateSerialNumberPage({ license }) {
   const { setCurrentSubTab, setLicense } = useLicenseDetails();
   const [serialNumber, setSerialNumber] = useState(license?.serialNumber ?? "");
   const [errors, setErrors] = useState({});
   const [isSubmitting, setIsSubmitting] = useState(false);

   async function handleSubmit(event) {
      event.preventDefault();
      const validation = licenseSerialNumberSchema.safeParse({ serialNumber });
      if (!validation.success) {
         setErrors(getZodFieldErrors(validation.error));
         return;
      }
      setErrors({});
      setIsSubmitting(true);
      try {
         const response = await LicenseService.updateSerialNumber(
            license.id,
            serialNumber
         );
         if (response?.status >= 200 && response.status < 300) {
            const refreshedLicense = await LicenseService.getLicense(license.id);
            if (refreshedLicense?.status >= 200 && refreshedLicense.status < 300) {
               setLicense(refreshedLicense.data);
            }
            setCurrentSubTab(null);
         }
      } finally {
         setIsSubmitting(false);
      }
   }

   return (
      <div className="fade-in mt-0.5!">
         <div className="flex flex-row items-center justify-between">
            <h2 className="font-bold! text-[15px]!">Alterar número de série</h2>
         </div>
         <p className="mt-3! opacity-60 leading-snug!">
            Atualize o número de série do equipamento associado à licença.
         </p>
         <form className="flex flex-col gap-3 mt-7!" onSubmit={handleSubmit}>
            <Input
               type="text"
               name="serialNumber"
               id="serialNumber"
               labelText="Serial Number do Equipamento *"
               value={serialNumber}
               onChange={({ target }) => setSerialNumber(target.value)}
               placeholder="Digite o Serial Number"
               disabled={isSubmitting}
               error={errors.serialNumber}
            />
            <div className="w-full flex flex-row items-center justify-end gap-3! mt-6!">
               <Button
                  className="button-white"
                  label="Cancelar"
                  onClick={() => setCurrentSubTab(null)}
                  disabled={isSubmitting}
               />
               <Button
                  className="button-blue"
                  label="Salvar"
                  type="submit"
                  isLoading={isSubmitting}
                  disabled={isSubmitting}
               />
            </div>
         </form>
      </div>
   );
}
